import React from "react";
import axios from "axios";

import { renderToString } from "react-dom/server";

import Button from "@material-ui/core/Button";

import DocumentCreator from "../Creator";

export default class DocumentExport extends React.Component {
  get document() {
    return this.props.document ?? null;
  }

  renderToString(props = {}) {
    return renderToString(
      <DocumentCreator document={this.document} {...props} />
    );
  }

  async getPdfData() {
    const content = this.renderToString();

    const url = window.appConfig.apiEndpoint;
    const pdf = await axios.post(`${url}/pdf.php`, content, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/pdf",
      },
    });

    return pdf.data;
  }

  async getPdfDataFile() {
    return new File(
      [await this.getPdfData()],
      `${this.document.type}-${this.document.id}.pdf`,
      {
        type: "application/pdf",
      }
    );
  }
  async getPdfDataBlob() {
    return new Blob([await this.getPdfData()], {
      type: "application/pdf",
    });
  }

  async onClick() {
    const blob = new Blob([await this.getPdfData()], {
      type: "application/pdf",
    });

    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, "_blank");
  }

  render() {
    return <Button onClick={() => this.onClick()}>Download as PDF</Button>;
  }
}
